import React from "react";
import { twMerge } from "tailwind-merge";

const Line = ({
  className = "",
  width = "200px",
  height = "2px",
  backgroundColor = "bg-primary-background",
  ...props
}) => {
  return (
    <div
      className={twMerge(backgroundColor, className)}
      style={{
        width: width,
        height: height,
      }}
      {...props}
    />
  );
};

export default Line;
